import React from "react";

const ColorModeContext = React.createContext({
  toggleColorMode: () => {},
  setMode: (_) => {},
  setPrimaryColorLight: (_) => {},
  setPrimaryColorDark: (_) => {},
  setAppLogoLight: (_) => {},
  setAppLogoDark: (_) => {},
  setAppLogoFavicon: (_) => {},
  setAppLogoBackgroundLight: (_) => {},
  setAppLogoBackgroundDark: (_) => {},
});

export default ColorModeContext;
